import FormSubmissionEvent from '../datalayer/events/form-submission-event';
import DataLayerUser from '../datalayer/classes/datalayer-user';
import DataLayerUserName from '../datalayer/classes/datalayer-user-name';
import DataLayerUserLocation from '../datalayer/classes/datalayer-user-location';
import applyValidationMessages from '../utility/validation-messages';

let form = null;

export default {
    canInit: (selector) => {
        form = document.querySelector(selector);
        return form !== null;
    },
    init: () => {
        form.noValidate = true;
        form.addEventListener('submit', submitHandler);
    }
};

function submitHandler(e) {
    e.preventDefault();

    applyValidationMessages(form);
    const isValid = form.reportValidity();

    pushDataLayer();

    if (!isValid) {
        const firstInvalid = form.querySelector(':invalid');

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstInvalid.focus();
        }

        return;
    }

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';
    }

    grecaptcha.ready(function () {
        grecaptcha.execute('6LfC6-4tAAAAAN_jz9ln87vRaN6dXGduLeluXwnU', { action: 'contact' }).then(function (token) {
            const tokenField = form.querySelector('[name=RecaptchaToken]');
            if (tokenField) {
                tokenField.value = token;
            }
            form.submit();
        }).catch(function (err) {
            console.error('reCAPTCHA error:', err);
        });
    });
}

function pushDataLayer() {
    let subject = '';
    const subjectElement = field('DiscussTopic');
    const errors = Array.from(form.elements)
        .filter(element => element.willValidate && !element.validity.valid)
        .map(element => ({
            message: element.validationMessage
        }));
    
    if (subjectElement) {
        subject = value('DiscussTopic');
    }

    const dataLayerEvent = new FormSubmissionEvent('general_contact', errors, buildUser());
    dataLayerEvent.forms.formSubject = subject;
    dataLayerEvent.push();
}

function buildUser() {
    const dataLayerUser = new DataLayerUser();

    dataLayerUser.name = new DataLayerUserName(value('Name'));
    dataLayerUser.email = value('Email');
    dataLayerUser.telephone = value('Phone');
    dataLayerUser.location = new DataLayerUserLocation(null, null, null, value('Postcode'));

    return dataLayerUser;
}

function value(name) {
    return field(name).value;
}

function field(name) {
    return form.querySelector(`[name=${name}]`);
}